<script>
import ComingSoonTooltip from '@components/tooltips/coming-soon-tooltip.vue'

export default {
  components: {
    ComingSoonTooltip,
  },
  props: {
    group: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      shareRecordConfirm: false,
    }
  },
  computed: {},

  methods: {
    getStarted() {
      this.$emit('getStarted')
    },
    getStartedQR() {
      this.$emit('getStartedQR')
    },
    closeDialog() {
      this.$emit('closeDialog', false)
      setTimeout(() => {
        this.selected = null
      }, 500)
    },
  },
}
</script>

<template>
  <v-card color="#FFFFFF;" min-height="450px">
    <v-card-text>
      <!-- close button -->
      <div :class="$style.closeButtonDiv">
        <v-btn
          color="offblack"
          :class="$style.closeButton"
          icon
          @click="closeDialog"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <!-- card dialog -->
      <template>
        <v-row justify="center">
          <v-col cols="12" md="10" sm="10">
            <div align="center" class="mt-12">
              <img
                width="250"
                height="250"
                :class="$style.logo"
                :src="require('@assets/images/safehaven/SharingRecords01.svg')"
              />
            </div>

            <v-row class="mt-4">
              <p :class="$style.headText">Share your health records</p>
            </v-row>
            <!-- get started button -->
            <v-row no-gutters align="center" justify="center" class="mt-6">
              <v-btn
                :class="$style.getStartedButton"
                class="primary-btn"
                elevation="0"
                width="236"
                height="37"
                @click="getStarted"
              >
                <v-icon left>mdi-email-outline </v-icon>
                Share a link via email
              </v-btn>
            </v-row>
            <v-row no-gutters align="center" justify="center" class="mt-4">
              <ComingSoonTooltip top>
                <v-btn
                  :class="$style.getStartedButton"
                  class="primary-btn disabled-btn"
                  elevation="0"
                  width="236"
                  height="37"
                  @click="getStartedQR"
                >
                  <v-icon left>mdi-qrcode</v-icon>
                  Give 24 hour access
                </v-btn>
              </ComingSoonTooltip>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.logo {
  height: auto;
  padding-top: 0;
}
.closeButton {
  position: absolute;
  top: 20px;
  right: 0;
  padding-left: 0;
}
.closeButtonDiv {
  position: relative;
}

.headText {
  align-items: center;
  margin-left: 20px !important;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #454648;
}

.subheadText {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}

.getStartedButton {
  align-items: center !important;
  justify-content: center !important;
  width: 376px !important;
  height: 50px !important;
  text-transform: inherit !important;
  background: #0476d9;
  border-radius: 30px;
}
@media screen and (max-width: 1263px) {
  .getStartedButton {
    width: 340px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 960px) {
  .getStartedButton {
    top: 80px;
    width: 340px !important;
    height: 50px !important;
  }
  .headText {
    margin-left: 20px !important;
  }
  .subheadText {
    margin-left: 20px !important;
  }
  .logo {
    margin-top: 100px !important;
  }
}
@media screen and (max-width: 599px) {
  .getStartedButton {
    top: 80px;
    width: 340px !important;
    height: 50px !important;
  }
}
</style>
